import { post } from 'utilities/api'
import { getBlotterUrlFromHostAndPath } from 'utilities/url'

const autoTweetPrefix = 'blotter::auto:::'

export const generateAutoTweetId = (hostId: string, urlPath: string) =>
  `${autoTweetPrefix}${getBlotterUrlFromHostAndPath(hostId, urlPath)}`

export const isAutoGeneratedTweetId = (replyToId: string) =>
  replyToId.startsWith(autoTweetPrefix)

export const refreshTweetFromApi = async (tweetId: string) => {
  const result = await post('/tweet', { tweetId })
  return result?.data
}

export const updateTweetConversationIsEnabled = async (conversationId: string, externalId: string, isEnabled: boolean) => {
  const result = await post(`/conversations/${conversationId}/comments/${externalId}`, { isEnabled })
  return result?.data
}
